import { render, staticRenderFns } from "./gameRulesTab.vue?vue&type=template&id=38d86fe1&"
import script from "./gameRulesTab.vue?vue&type=script&lang=js&"
export * from "./gameRulesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports